import { Offer } from '../../../../services/exports/Interfaces';

export interface UnlockedOfferResult {
  offer: Offer;
  /** The € this offer takes off the CURRENT basket (0 when it does not apply to it). */
  profit: number;
}

/**
 * Which newly-unlocked offers deserve an "… has been unlocked" toast.
 *
 * UX point 8 (PROD-407): a BOGO / half-price handler hardcodes `isUnlocked: true` even when the
 * qualifying item is not in the basket, so those offers count as "unlocked" and used to toast
 * regardless (e.g. "2nd Poke Bowl Half Price unlocked" with no poke bowl in the cart). Only toast
 * offers that actually apply to the current basket — i.e. produce a real saving (`profit > 0`).
 *
 * The min-spend free-item offer is unlocked at the spend threshold with `profit === 0` until the
 * free item is added; its nudge is owned by the dedicated FreeItems modal watcher, so suppressing
 * its (redundant) generic toast here is intentional.
 *
 * `alreadyUnlockedIds` are offers already known-unlocked — only NEWLY unlocked offers toast.
 */
export default function pickOffersToToast(
  unlocked: UnlockedOfferResult[],
  alreadyUnlockedIds: Set<Offer['id']>,
): Offer[] {
  return unlocked
    .filter(({ profit }) => (profit ?? 0) > 0)
    .filter(({ offer }) => !alreadyUnlockedIds.has(offer.id))
    .map(({ offer }) => offer);
}
